// src/components/NavBar.js
import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MailIcon from '@mui/icons-material/Mail';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import SearchBar from './SearchBar';  // 引入封装好的SearchBar组件
import ChatList from './ChatList';

export default function NavBar() {
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchOpen, setSearchOpen] = useState(false);  // 控制SearchBar显示状态

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleSearchClick = () => {
        setSearchOpen(!searchOpen);  // 点击文本框后展开SearchBar
    };

    const isMenuOpen = Boolean(anchorEl);
    const menuId = 'primary-search-account-menu';

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    {/* 左侧的标题 */}
                    <Typography variant="h6" noWrap component="div" sx={{ cursor: 'pointer', marginRight: '20px' }}>
                        NorthTown
                    </Typography>

                    {/* 中间的搜索框 */}
                    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: 'white',
                                borderRadius: '4px',
                                padding: '0 10px',
                                cursor: 'pointer',
                                width: searchOpen ? '80%' : '40%',
                                transition: 'width 0.3s ease'
                            }}
                            onClick={handleSearchClick}  // 点击打开SearchBar
                        >
                            <SearchIcon />
                            <InputBase
                                placeholder="搜索职位、企业、求职者…"
                                inputProps={{ 'aria-label': 'search' }}
                                sx={{ ml: 2, flex: 1 }}
                                disabled={searchOpen}  // 禁用文本框点击时输入
                            />
                        </Box>
                    </Box>

                    {/* 右侧菜单项和用户图标 */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginLeft: '20px' }}>
                        <Button component={Link} to="/" color="inherit">首页</Button>
                        <Button component={Link} to="/recommended-jobs" color="inherit">职位</Button>
                        <Button component={Link} to="/recommended-candidates" color="inherit">推荐候选人</Button>
                        <Button component={Link} to="/connections" color="inherit">关系</Button>
                        
                        {/* 消息按钮 */}
                        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
                            <MailIcon />
                        </IconButton>

                        {/* 通知按钮 */}
                        <IconButton size="large" aria-label="show 17 new notifications" color="inherit">
                            <NotificationsIcon />
                        </IconButton>

                        {/* 用户账户图标 */}
                        <IconButton
                            size="large"
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* 用户菜单 */}
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                id={menuId}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem component={Link} to="/profile" onClick={handleMenuClose}>用户信息</MenuItem>
                <MenuItem component={Link} to="/settings" onClick={handleMenuClose}>设置</MenuItem>
                <MenuItem onClick={handleMenuClose}>退出</MenuItem>
            </Menu>

            <ChatList />

            {/* 搜索条，只有点击文本框后才显示 */}
            {searchOpen && (
                <Box sx={{ position: 'relative' }}>
                    <SearchBar onClose={() => setSearchOpen(false)} />  {/* 点击关闭后关闭搜索条 */}
                </Box>
            )}
        </>
    );
}